export default {
  ownerName: '京蘭　産業',
  ownerEmail: 'kyoran@gmail.com',
  facilityName: '○○○○○邸',
  year: 2025,
  kpis: {
    sales: '20,008,642円',
    profit: '408,642円',
    occupancy: '70％'
  },
  rooms: [
    {
      id: 1,
      name: '○○○○○邸',
      address: '〒600-8199 京都府京都市下京区万屋町339-5',
      frontend: '〒600-8128 京都市下京区河原町通上ノ口東入大工町495番地3、495番地4',
      profit: '17,823,220',
      yearly: { occupancy: 100, sales: '23600万', days: 365 },
      months: [
        { occupancy: 100, sales: '320.24万', days: 30 },
        { occupancy: 80, sales: '24万', days: 24 },
        { occupancy: 20, sales: '3万', days: 3 },
        { occupancy: 60, sales: '18万', days: 18 },
        { occupancy: 40, sales: '12万', days: 12 },
        { occupancy: 0, sales: '0万', days: 0 },
        { occupancy: 80, sales: '24万', days: 24 },
        { occupancy: 100, sales: '30万', days: 30 },
        { occupancy: 60, sales: '18万', days: 18 },
        { occupancy: 40, sales: '12万', days: 12 },
        { occupancy: 20, sales: '3万', days: 3 },
        { occupancy: 0, sales: '0万', days: 0 }
      ]
    },
    {
      id: 2,
      name: '京町家　東邸',
      address: '〒600-8001 京都府京都市下京区',
      frontend: '帳場未設定',
      profit: '4,102,000',
      yearly: { occupancy: 70, sales: '820万', days: 255 },
      months: [
        { occupancy: 70, sales: '68万', days: 21 },
        { occupancy: 50, sales: '40万', days: 15 },
        { occupancy: 90, sales: '88万', days: 27 },
        { occupancy: 40, sales: '12万', days: 12 },
        { occupancy: 30, sales: '8万', days: 9 },
        { occupancy: 10, sales: '2万', days: 3 },
        { occupancy: 80, sales: '70万', days: 24 },
        { occupancy: 100, sales: '90万', days: 31 },
        { occupancy: 60, sales: '50万', days: 18 },
        { occupancy: 55, sales: '44万', days: 16 },
        { occupancy: 45, sales: '30万', days: 13 },
        { occupancy: 20, sales: '8万', days: 6 }
      ]
    }
  ],
  chart: {
    yearA: 2025,
    yearB: 2026,
    seriesA: [12, 18, 22, 28, 20, 16, 24, 30, 26, 18, 14, 10],
    seriesB: [8, 12, 14, 18, 16, 12, 20, 22, 18, 14, 12, 9]
  },
  emptyRooms: false,
  settlementPublished: true,
  profile: {
    name: '京蘭　一太朗',
    accountNo: 'KH-001',
    loginId: 'kyoran@gmail.com',
    registeredAt: '2021.02.17',
    contractStart: '2021.02.17',
    accountType: 'オーナー',
    contractYears: '2年',
    bankName: '〇〇信用銀行',
    bankBranch: '〇〇支店',
    bankAccountNo: '000000',
    bankAccountName: '○○太郎',
    invoiceRegNo: '648468686',
    gender: '男',
    nationality: '日本',
    phone: '075-691-8800',
    birthYear: '1990',
    birthMonth: '01',
    birthDay: '07',
    email: 'kyoran@gmail.com',
    post1: '601',
    post2: '8021',
    address: '京都市南区東九条宇賀辺町26番3'
  },
  corpProfile: {
    companyName: '株式会社　京蘭',
    representative: '石倉佑一',
    name: '京蘭　一太郎'
  },
  contractFileName: '業務委託契約書_KH-001.pdf',
  settlementMeta: {
    guestName: '〇〇〇〇〇〇〇〇〇〇〇〇〇〇',
    period: '20○○年〇月',
    title: '精算金計算書',
    contractRate: '売上高22％契約',
    reportNote: '報告：毎月15日まで末締め翌末支払い',
    bankName: '〇〇信用銀行',
    bankBranch: '〇●支店',
    accountType: '普通口座',
    accountNo: '114514',
    accountName: '○〇太郎',
    accountId: 'T516145656879946',
    comment: 'サンプルテキストサンプルテキストサンプルテキストサンプルテキストサンプルテキストサンプルテキスト',
    company: '京蘭アセットマネージメント株式会社',
    companyZip: '〒600-8198',
    companyReg: '登録番号：T3130001076569',
    companyAddress: '京都府京都市下京区若松町433-1'
  },
  settlementIjk: {
    b: '〇',
    c: '〇',
    d: '〇',
    e: '〇',
    f: '〇',
    g: '〇',
    h: '〇',
    i: '789456',
    j: '46856',
    k: '564231',
    taxed: '〇',
    taxIn: '〇',
    taxOut: '〇',
    taxRate: '〇'
  },
  settlementRows: [
    {
      id: 1,
      name: '○○邸',
      stays: [
        {
          checkin: '2025-01-01',
          checkout: '2025-01-03',
          days: '3',
          guests: '1',
          income: '10,000,000',
          tax: '-〇',
          a: '-〇',
          b: '-〇',
          c: '-〇',
          d: '-〇',
          e: '-〇',
          f: '-〇',
          g: '-〇',
          h: '-〇',
          ownerIncome: '1,000,000'
        },
        {
          checkin: '〇',
          checkout: '〇',
          days: '1',
          guests: '6',
          income: '〇',
          tax: '-〇',
          a: '-〇',
          b: '-〇',
          c: '-〇',
          d: '-〇',
          e: '-〇',
          f: '-〇',
          g: '-〇',
          h: '-〇',
          ownerIncome: '1,000,000'
        }
      ],
      months: [
        { profit: '80万', adr: '12,000', occ: '70％' },
        { profit: '64万', adr: '11,200', occ: '50％' },
        { profit: '90万', adr: '13,400', occ: '90％' },
        { profit: '40万', adr: '10,800', occ: '40％' },
        { profit: '28万', adr: '9,600', occ: '30％' },
        { profit: '8万', adr: '8,000', occ: '10％' },
        { profit: '70万', adr: '12,800', occ: '80％' },
        { profit: '96万', adr: '14,000', occ: '100％' },
        { profit: '50万', adr: '11,000', occ: '60％' },
        { profit: '44万', adr: '10,400', occ: '55％' },
        { profit: '30万', adr: '9,200', occ: '45％' },
        { profit: '12万', adr: '8,400', occ: '20％' }
      ]
    },
    {
      id: 2,
      name: '京町家　東邸',
      stays: [
        {
          checkin: '2025-06-02',
          checkout: '2025-06-05',
          days: '3',
          guests: '2',
          income: '240,000',
          tax: '-2,000',
          a: '238,000',
          b: '-23,800',
          c: '-52,360',
          d: '-12,000',
          e: '-3,000',
          f: '-6,000',
          g: '-8,000',
          h: '-4,000',
          ownerIncome: '128,840'
        },
        {
          checkin: '2025-06-18',
          checkout: '2025-06-20',
          days: '2',
          guests: '4',
          income: '180,000',
          tax: '-1,000',
          a: '179,000',
          b: '-17,900',
          c: '-39,380',
          d: '-8,000',
          e: '-2,000',
          f: '-4,000',
          g: '-8,000',
          h: '-4,000',
          ownerIncome: '95,720'
        }
      ],
      months: [
        { profit: '32万', adr: '9,800', occ: '62％' },
        { profit: '28万', adr: '9,200', occ: '48％' },
        { profit: '41万', adr: '10,600', occ: '72％' },
        { profit: '18万', adr: '8,800', occ: '36％' },
        { profit: '15万', adr: '8,400', occ: '28％' },
        { profit: '6万', adr: '7,600', occ: '12％' },
        { profit: '38万', adr: '10,200', occ: '68％' },
        { profit: '52万', adr: '11,400', occ: '88％' },
        { profit: '26万', adr: '9,000', occ: '50％' },
        { profit: '22万', adr: '8,700', occ: '44％' },
        { profit: '19万', adr: '8,500', occ: '38％' },
        { profit: '9万', adr: '7,800', occ: '18％' }
      ]
    }
  ]
};
